<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"
            ><i class="icon-close"></i
          ></a>
          <h3 v-if="open" class="modal-title">
            請選擇發送客戶「專屬邀請函」的方式
          </h3>
        </div>
        <div
          v-if="open"
          class="modal-body send-modal-body"
          style="min-height:120px;"
          :class="{ 'section-loading': sendLoading }"
        >
          <div style="text-align:center;">
            <a @click="Openmail()" class="btn btn-primary"
              >&emsp; 發送Email&emsp;<br />邀請函</a
            >
            <a @click="SendMSG()" class="btn btn-primary"
              >發送簡訊(手機)<br />邀請函</a
            >
          </div>
        </div>
      </div>
    </div>

    <!-- 信函選擇 -->
    <letter-choice-modal
      :open="LetterChoiceModalOpen"
      @send="SendEmail"
      @close="closeLetter()"
    />
    <!-- 沒有資訊 -->
    <warning-modal
      :message="message + par"
      :open="warningModalOpen"
      :showCancel="false"
      :confirmText="'我知道了'"
      @submit="ClosewarningModal()"
    />
    <!-- 今天已寄 -->
    <warning-modal2
      :message="message2"
      :name="par2"
      :open="warningModal2Open"
      :showCancel="false"
      :confirmText="'我知道了'"
      @send="ClosewarningModal2()"
    />
  </div>
</template>

<script>
import {mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import LetterChoiceModal from "./LetterChoiceModal";
import {
  invitation_SendEmail,
  invitation_SendMSG,
  getIonlyU_csid,
} from "@/service";
import WarningModal from "@/desktop/components/WarningModal";
import WarningModal2 from "@/desktop/components/WarningModal2";
import moment from "moment";

export default {
  name: "InvitationModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    custs: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  components: {
    LetterChoiceModal,
    WarningModal,
    WarningModal2
  },
  data() {
    return {
      sendLoading: false,
      LetterChoiceModalOpen: false,
      tableData: [],
      tableDataBackup: [],
      warningModalOpen: false,
      warningModal2Open: false,
      method: "",
      type: "",
      notexist: "",
      notList: [],
      message: "",
      par: "",
      message2: "",
      par2: "",
      uniqueCust: [],
      no_msg_list: [],
      have_msg_list: [],
      no_email_list: [],
      have_email_list: [],
      already_sendMSG_name: [],
      already_sendEmail_name: [],
      CanSendEmData: [],
      CanSendMSGData: []
    };
  },
  watch: {
    open: "init"
  },
  methods: {
    ...mapActions(["setPageLock"]),
    init() {
      // 初始化
      if (this.open) {
        this.sendLoading = true;
        this.uniqueCust = [...new Set(this.custs)]; //過濾掉重複ID的資料
        getIonlyU_csid(this.$store.state.userInfo.id, this.uniqueCust).then(
          result => {
            this.sendLoading = false;
            if (result.header && result.header.status === "200") {
              this.tableData = result.body.lists.map(item => {
                if (!item.mobile) {
                  this.no_msg_list.push(item.name);
                } else {
                  this.have_msg_list.push(item);
                }
                if (!item.email) {
                  this.no_email_list.push(item.name);
                } else {
                  this.have_email_list.push(item);
                }
                return {
                  name: item.name || "", //客戶姓名
                  sex: Number(item.customer_id[1]), //性別
                  vip_lv: item.vip_lvl, //顯示VIP
                  agnt_id: item.agnt_id || "", //姓名(要保人資料）
                  ceapcno: item.customer_id || "", //客戶id
                  data_intime: item.data_intime || "", //排程資料進來的時間
                  digital_contact_tag: item.digital_contact_tag || "", //數位接觸率標籤
                  email: item.email || "",
                  email_open_time: item.email_open_time || "", //email發送或開啟的時間
                  list_end_time: item.list_end_time || "", //名單結束時間
                  list_upload_time: item.list_upload_time || "", //	名單開始時間
                  mobile: item.mobile || "",
                  prod_id: item.prod_id || "", //	商品代號
                  sms_open_time: item.sms_open_time || "", //簡訊發送的時間
                  is_netinsr: item.is_netinsr || "", //網路投保資格
                  birthday: item.birthday || "", //生日
                  age: item.age || "" //年齡
                };
              });
              this.tableDataBackup = this.tableData.map(ele => {
                return ele;
              });
              this.registerHanlink(); // for hard word

              if (this.no_msg_list.length != 0) {
                this.no_msg_list = this.no_msg_list.join("、");
              }

              if (this.no_email_list.length != 0) {
                this.no_email_list = this.no_email_list.join("、");
              }
            }
          }
        );
      }
    },
    closeLetter() {
      this.panelClose("LetterChoiceModalOpen");
      this.clear();
    },
    Openmail() {
      this.panelOpen("LetterChoiceModalOpen");
    },
    SendEmail(value) {
      this.panelClose("LetterChoiceModalOpen");
      this.type = value;
      let today = moment().format("YYYY-MM-DD");
      //取得今天已有寄送名單(已先排除無email名單)
      this.have_email_list.map(item => {
        //有email寄送時間戳記
        if (item.email_open_time) {
          item.email_open_time = moment(item.email_open_time).format(
            "YYYY-MM-DD"
          );
          //時間是今天
          if (today == item.email_open_time) {
            this.already_sendEmail_name.push(item.name);
          } else {
            this.CanSendEmData.push(item);
          }
          //沒有email寄送時間戳記-->可以寄送
        } else {
          this.CanSendEmData.push(item);
        }
      });
      if (this.already_sendEmail_name.length != 0) {
        this.already_sendEmail_name = this.already_sendEmail_name.join("、");
        this.panelOpen("warningModal2Open");
        this.method = "EMAIL"; //CheckDup
        this.message2 =
          "<span style=color:red;>提醒您，下列客戶本日已經發送邀請函過了呦!避免過度打擾客戶，明天再發送吧</span><br/>";
        this.par2 = this.already_sendEmail_name;
      } else {
        this.method = "EMAIL";
        this.ClosewarningModal2();
      }
    },
    SendMSG() {
      let today = moment().format("YYYY-MM-DD");
      this.have_msg_list.map(item => {
        //有MSG寄送時間戳記
        if (item.sms_open_time) {
          item.sms_open_time = moment(item.sms_open_time).format("YYYY-MM-DD");
          //時間是今天
          if (today == item.sms_open_time) {
            this.already_sendMSG_name.push(item.name);
          } else {
            this.CanSendMSGData.push(item);
          }
          //沒有MSG寄送時間戳記-->可以寄送
        } else {
          this.CanSendMSGData.push(item);
        }
      });
      if (this.already_sendMSG_name.length != 0) {
        this.already_sendMSG_name = this.already_sendMSG_name.join("、");
        this.panelOpen("warningModal2Open");
        this.method = "MSG";
        this.message2 =
          "<span style=color:red;>提醒您，下列客戶本日已經發送邀請函過了呦!避免過度打擾客戶，明天再發送吧</span><br/>";
        this.par2 = this.already_sendMSG_name;
      } else {
        this.method = "MSG";
        this.ClosewarningModal2();
      }
    },
    CheckIfHaveMsgList() {
      this.notexist = "手機號碼";
      this.notList = this.no_msg_list;
      if (this.no_msg_list.length != 0) {
        this.panelOpen("warningModalOpen");
      } else {
        this.SendMsgAPI();
      }
      this.method = "MSG";
      this.message =
        "<span style=color:red;>下列客戶因沒有手機號碼，故本次將不發送專屬邀請函。</span><br/>";
      this.par = this.no_msg_list;
    },
    CheckIfHaveEmailList() {
      this.notexist = "EMAIL";
      this.notList = this.no_email_list;
      this.method = "EMAIL";
      this.message =
        "<span style=color:red;>下列客戶因沒有Email，故本次將不發送專屬邀請函。</span><br/>";
      this.par = this.no_email_list;
      if (this.no_email_list.length != 0) {
        this.panelOpen("warningModalOpen");
      } else {
        this.SendEmailAPI();
      }
    },
    ClosewarningModal() {
      this.panelClose("warningModalOpen");
      if (this.method == "MSG") {
        this.SendMsgAPI();
      } else if (this.method == "EMAIL") {
        this.SendEmailAPI();
      }
    },
    ClosewarningModal2() {
      this.panelClose("warningModal2Open");
      if (this.method == "MSG") {
        this.CheckIfHaveMsgList();
      } else if (this.method == "EMAIL") {
        this.CheckIfHaveEmailList();
      }
    },
    SendMsgAPI() {
      this.sendLoading = true;
      if (this.CanSendMSGData.length == 0) {
        this.sendLoading = false;
        this.setToastMsg("無可寄送名單");
        this.clear();
      } else {
        invitation_SendMSG(
          this.$store.state.userInfo.id,
          this.CanSendMSGData
        ).then(result => {
          if (result.header && result.header.status === "200") {
            this.sendLoading = false;
            if (result.header.message) {
              this.setToastMsg(result.header.message);
            }
            this.clear();
          } else {
            this.sendLoading = false;
            this.setToastMsg(result.header.message);
            this.clear();
          }
        });
      }
    },
    SendEmailAPI() {
      this.sendLoading = true;
      if (this.CanSendEmData.length == 0) {
        this.sendLoading = false;
        this.setToastMsg("無可寄送名單");
        this.clear();
      } else {
        invitation_SendEmail(
          this.$store.state.userInfo.id,
          this.CanSendEmData,
          this.type
        ).then(result => {
          if (result.header && result.header.status === "200") {
            this.sendLoading = false;
            this.setToastMsg(result.header.message);
            this.clear();
          } else {
            this.sendLoading = false;
            this.setToastMsg(result.header.message);
            this.clear();
          }
        });
      }
    },
    clear() {
      this.no_msg_list = [];
      this.have_msg_list = [];
      this.no_email_list = [];
      this.have_email_list = [];
      this.already_sendMSG_name = [];
      this.already_sendEmail_name = [];
      this.CanSendEmData = [];
      this.CanSendMSGData = [];
      this.$emit("close");
    }
  }
};
</script>
